"use client";

import { c as _c } from "react/compiler-runtime";
import { type HTMLAttributes, useState } from "react";
import type { Offer } from "@local/offer/src/types";
import { cn } from "@local/utils/src/cn";
import Image from "next/image";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { Stars, Avatar, Button } from "../../ui";
interface SingleReviewProps extends HTMLAttributes<HTMLDivElement> {
  review: NonNullable<Offer.FullWidthReviews["reviews"]>[number];
}
export const SingleReview = t0 => {
  const $ = _c(38);
  let className;
  let rest;
  let review;
  if ($[0] !== t0) {
    ({
      review,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = review;
  } else {
    className = $[1];
    rest = $[2];
    review = $[3];
  }
  const [readMore, setReadMore] = useState(false);
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setReadMore(true);
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const openReview = t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("flex w-full flex-col gap-4 md:mb-8", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== review.image) {
    t3 = review.image?.url && <Image src={getCdnUrl({
      src: review.image.url as string,
      width: review.image.width || 640
    })} width={review.image.width || 640} height={review.image.height || 640} alt={review.image.filename as string} className="aspect-square w-full" />;
    $[7] = review.image;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = parseFloat(review.starsRating);
  let t5;
  if ($[9] !== t4) {
    t5 = <Stars rating={t4} />;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = readMore ? review.content : review.content.substring(0, 94) + "...";
  let t7;
  if ($[11] !== t6) {
    t7 = <p className="mb-4">{t6}</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== readMore) {
    t8 = !readMore && <Button onClick={() => openReview()} className="mb-4 w-full max-w-full self-start text-left text-base! underline shadow-none!" variant="link" size="link">Read More</Button>;
    $[13] = readMore;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="flex grow flex-col">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== review.avatar || $[19] !== review.name) {
    t10 = <Avatar name={review.name} size="sm" image={review.avatar} />;
    $[18] = review.avatar;
    $[19] = review.name;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== review.name) {
    t11 = <b>{review.name}</b>;
    $[21] = review.name;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== review.location) {
    t12 = <span className="font-gray-700 block text-sm">{review.location}</span>;
    $[23] = review.location;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <div><p className="mb-1 leading-tight">{t11}{t12}</p></div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t13) {
    t14 = <div className="flex flex-row items-center gap-4">{t10}{t13}</div>;
    $[28] = t10;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== rest || $[32] !== t14 || $[33] !== t2 || $[34] !== t3 || $[35] !== t5 || $[36] !== t9) {
    t15 = <div className={t2} {...rest}>{t3}{t5}{t9}{t14}</div>;
    $[31] = rest;
    $[32] = t14;
    $[33] = t2;
    $[34] = t3;
    $[35] = t5;
    $[36] = t9;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
};